import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { register } from "../api";
import "../Auth.css";

function Signup() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    phoneNumber: ""
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await register(formData);
      navigate("/userlogin");
    } catch (err) {
      setError(err.response?.data?.message || "Signup failed");
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-wrapper" style={{maxWidth: '1100px'}}>
        <div className="auth-visual">
          <h2>Join RepairMate</h2>
          <p>Create an account to access fast, reliable, and professional appliance repair services at your convenience.</p>
        </div>

        <div className="auth-content" style={{padding: '40px 60px'}}>
          <div className="auth-form-header" style={{marginBottom: '25px'}}>
            <h1>Create Account</h1>
            <p>Start your journey with us today</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="auth-form-group">
              <label className="auth-label">Full Name</label>
              <div className="auth-input-wrapper">
                <i className="fas fa-user"></i>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="John Doe"
                  required
                  className="auth-input"
                />
              </div>
            </div>

            <div className="auth-form-group">
              <label className="auth-label">Email Address</label>
              <div className="auth-input-wrapper">
                <i className="fas fa-envelope"></i>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="john@example.com"
                  required
                  className="auth-input"
                />
              </div>
            </div>

            <div className="auth-form-group">
              <label className="auth-label">Phone Number</label>
              <div className="auth-input-wrapper">
                <i className="fas fa-phone"></i>
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  placeholder="+91 98765 43210"
                  required
                  className="auth-input"
                />
              </div>
            </div>

            <div style={{display: 'flex', gap: '15px'}} className="auth-form-group-row">
              <div className="auth-form-group" style={{flex: 1}}>
                <label className="auth-label">Password</label>
                <div className="auth-input-wrapper">
                  <i className="fas fa-lock"></i>
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="••••••••"
                    required
                    className="auth-input"
                  />
                </div>
              </div>
              <div className="auth-form-group" style={{flex: 1}}>
                <label className="auth-label">Confirm</label>
                <div className="auth-input-wrapper">
                  <i className="fas fa-check-circle"></i>
                  <input
                    type="password"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    placeholder="••••••••"
                    required
                    className="auth-input"
                  />
                </div>
              </div>
            </div>

            <button type="submit" disabled={loading} className="auth-submit-btn" style={{marginTop: '10px'}}>
              {loading ? "Creating Account..." : "Sign Up Now"}
            </button>
            
            {error && <div style={{color: '#dc3545', marginTop: '10px', textAlign: 'center', fontSize: '0.85rem'}}>{error}</div>}
          </form>

          <div className="auth-footer" style={{marginTop: '25px'}}>
            Already have an account? <Link to="/userlogin" className="auth-link">Log in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Signup;
